<template>
  <div class="container" v-show="show">
    <img-v3 :src="formItem.img_url" @click="goLink" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";

export default {
  props: ["formItem", "idx", "omegaItem"],
  methods: {
    reset() {
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2,
        });
      //20200228 vamos设置返回拦截
      Fusion.interceptGoback &&
        Fusion.interceptGoback({ needs_intercept: false }, () => {});
    },
    closePage() {
      Fusion.closePage && Fusion.closePage({ needs_intercept: true }, () => {});
    },
    goLink() {
      if (this.formItem.link_type === "download") {
        this.omegaEvent();
        this.reset();
        // ?source=google&utm_campaign=DRVSUP&utm_source=google_search&campaign_id=100&ad_group_id=200&creative_id=300&keyword=DriverJob&adposition=1&gclid=12345
        // console.log(this.linkGenerator(this.formItem.link.ios));
        let up = new URLSearchParams(location.search);
        let country = up.get("location_country");
        const isGenerator = country === "BR" && this._product === 2;
        if (ends.isIOS) {
          location.href = isGenerator
            ? this.linkGenerator(this.formItem.link.ios)
            : this.formItem.link.ios;
        } else {
          location.href = isGenerator
            ? this.linkGenerator(this.formItem.link.android)
            : this.formItem.link.android;
        }
        // if (ends.isIOS) {
        //   location.href = this.formItem.link.ios;
        // } else {
        //   location.href = this.formItem.link.android;
        // }
      } else if (this.formItem.link_type === "goback_bridge") {
        let up = new URLSearchParams(location.search);
        if (up.get("bridge_open") == 1) {
          Fusion.openVamos
            ? Fusion.openVamos({
                URL: "taxis99onetravel://one/product/switch?role=driver&groupType=vamos&switchRole=1&closeSideMenu=1&clearTop=1",
              })
            : this.closePage();
        } else {
          this.closePage();
        }
      } else {
        this.reset();
        // @20201110 兼容只配图片不配链接的情况
        if (this.formItem.link_type === "link_get_params") {
          let url = this.formItem.link;
          let up = new URLSearchParams(location.search);
          if (this._ticket) {
            up.set("ticket", this._ticket);
          }
          if (this._area && this._area.value) {
            up.set("areaId", this._area.value);
          }
          if (this._area && this._area.text) {
            up.set("areaName", this._area.text);
          }
          if (url.indexOf("?") > -1) {
            url = `${url}&${up}`;
          } else {
            url = `${url}?${up}`;
          }
          if (ends.inApp) {
            Fusion.openPage && Fusion.openPage({
              url: url,
              newWindow: true,
            });
          } else {
            window.open(url)
          }
        } else {
          this.formItem.link && (location.href = this.formItem.link);
        }
      }
    },
    linkGenerator(url) {
      const onelinkGenerator = new window.AF.OneLinkUrlGenerator({
        oneLinkURL: url,
        pidKeysList: ["source"],
        // pidOverrideList: {
        //   'joveo': 'joveo_int',
        //   'jampp': 'jampp_int',
        //   'google': 'googleadwords_int',
        //   'facebook':'Facebook Ads'
        // },
        campaignKeysList: ["utm_campaign"],
      });
      onelinkGenerator.setChannel("utm_source"); // Input value
      onelinkGenerator.setCustomParameter("campaign_id", "af_c_id"); // Input Output value
      onelinkGenerator.setAdset("ad_group_id");
      onelinkGenerator.setAd("creative_id");
      onelinkGenerator.setCustomParameter("keyword", "af_keywords");
      onelinkGenerator.setCustomParameter("adposition", "af_siteid");
      onelinkGenerator.setAfSub1("gclid");
      onelinkGenerator.setAfSub2("fbclid");
      return onelinkGenerator.generateUrl();
    },
    omegaEvent() {
      let step = 8;
      let name = this.$route.name;
      if (/^login/.test(name)) {
        step = 0; //注册页
      } else if (/^productInfo/.test(name)) {
        step = 1; // 产品线选择页
      } else if (/^typeInfo/.test(name)) {
        step = 2; // 角色选择页
      } else if (/^workInfo/.test(name)) {
        step = 9; // 工作选择页-新增
      } else if (/^baseInfo/.test(name)) {
        step = 3; // 基础信息页
      } else if (/^photoInfo/.test(name)) {
        step = 4; // 证件列表页
      } else if (/^result/.test(name)) {
        step = 5; // 结果页
      } else if (/^downloadInfo/.test(name)) {
        step = 6; // 下载引导页
      } else if (/^prepareInfo/.test(name)) {
        step = 7; // 准备页
      } else {
        step = 8; // 其他页面
      }
      try {
        Omega.trackEvent("ibt_gd_approvalresult_banner_ck", "", {
          ...this.omegaItem,
          step: step,
        });
      } catch (error) {}
    },
  },
  computed: {
    ...mapState(["_ticket", "_product", "_area"]),
    show() {
      let end = getEnd();
      let d = this.formItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0;
  margin-top: 0.4rem;
}
img {
  display: block; //解决下边距3px空白
  width: 100%;
}
</style>

